import type {
  ModalQueueFragmentParam,
  QueryParamsHandling
} from '@bcf-vanilla-ts-v1-logic-worker-modals/bloc/modal-outlet/types';
import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import {
  provideBcfRouterService,
  type BcfRouterService
} from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-router.service';
import type { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import type { ModalKindStandard } from './types';

export class ModalQueueNavigatorService {
  private _doRemoveFirstModalFromQueue$: Subject<QueryParamsHandling> = new Subject<QueryParamsHandling>();
  private _doRemoveFirstModalFromQueueAndMoveToRedirectQueue$: Subject<void> = new Subject<void>();
  private _doJustRemoveFirstModalFromQueue$: Subject<void> = new Subject<void>();

  constructor(private _router: BcfRouterService) {}

  public doRemoveFirstModalFromQueue(): Observable<QueryParamsHandling> {
    return this._doRemoveFirstModalFromQueue$;
  }

  public doRemoveFirstModalFromQueueAndMoveToRedirectQueue(): Observable<void> {
    return this._doRemoveFirstModalFromQueueAndMoveToRedirectQueue$;
  }

  public doJustRemoveFirstModalFromQueue(): Observable<void> {
    return this._doJustRemoveFirstModalFromQueue$;
  }

  public removeFirstModalFromQueue(queryParamsHandling: QueryParamsHandling = 'preserve'): void {
    this._doRemoveFirstModalFromQueue$.next(queryParamsHandling);
  }

  public removeFirstModalFromQueueAndMoveToRedirectQueue(): void {
    this._doRemoveFirstModalFromQueueAndMoveToRedirectQueue$.next(undefined);
  }

  public justRemoveFirstModalFromQueue(): void {
    this._doJustRemoveFirstModalFromQueue$.next(undefined);
  }

  public async clearFragment(): Promise<void> {
    this._router.updateFragment(undefined);
  }

  public navigateToModalFragment() {
    return ([modalFragmentLink, modalFragmentParam, _routerPath]: [
      ModalKindStandard,
      ModalQueueFragmentParam,
      string | undefined
    ]): void => {
      if (modalFragmentParam) {
        this._router.updateFragment(`modal-${modalFragmentLink}`, [modalFragmentParam.toString()]);
        return;
      }
      this._router.updateFragment(`modal-${modalFragmentLink}`);
    };
  }
}
export function provideModalQueueNavigatorService(): ModalQueueNavigatorService {
  return provideSingleton(ModalQueueNavigatorService, () => new ModalQueueNavigatorService(provideBcfRouterService()));
}
